import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./Textarea.module.scss";
export const Textarea = React.forwardRef(({ label, hint, error, showCounter, autosize = false, className, id, maxLength, value, defaultValue, onChange, rows = 4, ...rest }, ref) => {
    const reactId = React.useId();
    const inputId = id ?? reactId;
    const localRef = React.useRef(null);
    React.useImperativeHandle(ref, () => localRef.current);
    // Autosize: reset to natural height before measuring so it can shrink too.
    React.useLayoutEffect(() => {
        if (!autosize)
            return;
        const el = localRef.current;
        if (!el)
            return;
        el.style.height = "auto";
        el.style.height = `${el.scrollHeight}px`;
    }, [autosize, value]);
    const [internal, setInternal] = React.useState(typeof defaultValue === "string" ? defaultValue : "");
    const isControlled = value !== undefined;
    const text = isControlled ? String(value ?? "") : internal;
    const handleChange = (e) => {
        if (!isControlled)
            setInternal(e.target.value);
        onChange?.(e);
    };
    return (_jsxs("div", { className: cn(styles.wrap, className), children: [label && (_jsx("label", { className: styles.label, htmlFor: inputId, children: label })), _jsx("textarea", { ref: localRef, id: inputId, className: cn(styles.field, error ? styles.invalid : undefined), maxLength: maxLength, value: isControlled ? value : undefined, defaultValue: !isControlled ? defaultValue : undefined, onChange: handleChange, rows: rows, style: autosize ? { resize: "none", overflow: "hidden" } : undefined, ...rest }), _jsxs("div", { className: styles.footer, children: [error ? (_jsx("span", { className: styles.error, children: error })) : hint ? (_jsx("span", { className: styles.hint, children: hint })) : (_jsx("span", {})), (showCounter || maxLength != null) && (_jsxs("span", { className: styles.counter, children: [text.length, maxLength != null ? ` / ${maxLength}` : ""] }))] })] }));
});
Textarea.displayName = "Textarea";
